import React from 'react';
import { SearchIcon } from '../Icons';
import { useHistory } from 'react-router-dom';

const SearchBar = props => {
  const history = useHistory();
  const handleSearchClickBound = () => {
    history.push('/search');
    if (props.handleSearchClick) {
      props.handleSearchClick();
    }
  };
  return (
    <div
      className={`search-container ${props.customClassName ? props.customClassName : ''}`}
      onClick={handleSearchClickBound}
    >
      <SearchIcon className={`search-icon ${props.customClassName ? props.customClassName : ''}`} />
    </div>
  );
};

export default SearchBar;
